import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import Player from './components/Player';
import Home from './pages/Home';
import Create from './pages/Create';
import Library from './pages/Library';
import Explore from './pages/Explore';
import Auth from './pages/Auth';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import SongPage from './pages/SongPage';
import OfflineBanner from './components/OfflineBanner';
import { Toaster } from './components/ui/toaster';

function Layout({ children }) {
  const location = useLocation();
  const isAuth = location.pathname.startsWith('/auth');
  if (isAuth) return <>{children}</>;
  return (
    <div className="flex min-h-screen bg-[#0a0a0b] text-zinc-100">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        <main className="flex-1 pb-28">{children}</main>
      </div>
      <Player />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/create" element={<Create />} />
              <Route path="/library" element={<Library />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/u/:userId" element={<Profile />} />
              <Route path="/s/:id" element={<SongPage />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
          <OfflineBanner />
          <Toaster />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
